import { render } from "./VerticalProduct.vue?vue&type=template&id=fbeaa048&scoped=true"
import script from "./VerticalProduct.vue?vue&type=script&lang=js"
export * from "./VerticalProduct.vue?vue&type=script&lang=js"

import "./VerticalProduct.vue?vue&type=style&index=0&id=fbeaa048&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbeaa048"]])

export default __exports__